// extracted by css-extract-rspack-plugin
export default {"list":"yZwbGR4iqIEysqYd","item":"U4j81qYnxCkeiiY4 yjEOWr1wvMI7B708"};